import { Box, Divider, Paper, Typography } from "@material-ui/core";
import React from "react";
import BackButton from "../../../app/components/buttons/BackButton";
import Header from "../../../app/components/Header";
import PdfContainer from "../../../app/components/PdfContainer";
import MonthlyCorrectionsReportFilter from "../components/MonthlyCorrectionsReportFilter";
import { useMonthlyCorrectionsReportPage } from "../hooks/useMonthlyCorrectionsReportPage";

const MonthlyCorrectionsReportPage = () => {
  const {
    providers,
    invoiceYears,
    getInvoiceYearsRequestState,
    getDocumentRequestState,
    getProvidersRequestState,
    document,
    handleSearch,
    isFnyfsUser,
  } = useMonthlyCorrectionsReportPage();

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div>
        <BackButton route="/reports" />
      </div>
      <Header title="Monthly Corrections Report" />
      <Box className="my-2">
        <Typography>
          Select month/year{isFnyfsUser && ", Provider (optional)"} and "View"
          for a PDF summary of corrections created in the selected month.
        </Typography>
      </Box>
      <Paper
        style={{
          padding: "16px",
          height: "calc(100% - 20px)",
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        <MonthlyCorrectionsReportFilter
          providers={providers}
          getProvidersRequestState={getProvidersRequestState}
          requestState={getDocumentRequestState}
          invoiceYears={invoiceYears}
          getInvoiceYearsRequestState={getInvoiceYearsRequestState}
          onSubmit={handleSearch}
        />

        <Box marginBottom="8px" marginTop="8px">
          <Divider />
        </Box>
        <PdfContainer
          document={document}
          isLoading={getDocumentRequestState.isLoading}
        />
      </Paper>
    </div>
  );
};

export default MonthlyCorrectionsReportPage;
